import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { decryptData } from '../../EncryptDecrypt';
import Background from "../../../assets/images/search-icon.png"

const SearchBar = ({ list = [], filterData, encoded = false, placeholder = "Search...", page, setPage, label }) => {
    const [searchVal, setSearchVal] = useState("");
    const getName = (nameField) => {
        return typeof nameField === "string" ? nameField : nameField?.[0]?.text
    }
    const filter = () => {
        const trimmed = (searchVal ?? "").trim().toLowerCase();
        const data = encoded ?
            list?.filter((data) =>
                decryptData(getName(data?.name))?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.telecom?.[1]?.value)?.toLowerCase()?.includes(trimmed) ||
                decryptData(getName(data?.patientName))?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.message)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.patientEmail)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.documentName)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.category?.[0]?.coding?.[0]?.display)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.custodian?.display)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.status)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.author?.[0]?.display)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.category?.[0]?.coding?.[0]?.display)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.numPages)?.includes(trimmed) ||
                decryptData(data?.authenticator?.[0]?.display)?.toLowerCase()?.includes(trimmed) ||
                decryptData( data?.submittedBy?.coding?.[0]?.code === "fax" ?  data?.submittedBy?.coding?.[0]?.display : data?.submittedBy?.name)?.toLowerCase()?.includes(trimmed) ||
                decryptData(data?.subject?.name)?.toLowerCase()?.includes(trimmed)
            ) :
            list?.filter((data) =>
                getName(data?.name)?.toLowerCase()?.includes(trimmed) ||
                data?.telecom?.[1]?.value?.toLowerCase()?.includes(trimmed) ||
                data?.title?.toLowerCase()?.includes(trimmed) ||
                data?.display?.toLowerCase()?.includes(trimmed) ||
                data?.question?.toLowerCase()?.includes(trimmed) ||
                data?.name?.toLowerCase()?.includes(trimmed) ||
                data?.categoryName?.toLowerCase()?.includes(trimmed) ||
                data?.categoryType?.toLowerCase()?.includes(trimmed) ||
                data?.documentName?.toLowerCase()?.includes(trimmed) ||
                data?.category?.[0]?.coding?.[0]?.display?.toLowerCase()?.includes(trimmed) ||
                data?.custodian?.display?.toLowerCase()?.includes(trimmed) ||
                data?.status?.toLowerCase()?.includes(trimmed) || 
                data?.sender?.practitioner_name?.toLowerCase()?.includes(trimmed) ||
                data?.sender?.organization_name?.toLowerCase()?.includes(trimmed) ||
                data?.author?.[0]?.display?.toLowerCase()?.includes(trimmed) ||
                data?.category?.[0]?.coding?.[0]?.display?.toLowerCase()?.includes(trimmed) ||
                data?.numPages?.includes(trimmed) ||
                data?.authenticator?.[0]?.display?.toLowerCase()?.includes(trimmed) ||
                data?.submittedBy?.coding?.[0]?.code === "fax" ?  "Fax" : data?.submittedBy?.name?.toLowerCase()?.includes(trimmed) ||
                data?.subject?.display?.toLowerCase()?.includes(trimmed)
                
            )
        filterData(data);
    }
    useEffect(() => {
        filter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchVal, list])
    return (
        <Form className="search-wrap">
            {label && <label>{label}</label>}
            <Form.Control
                type="search"
                placeholder={placeholder}
                className="me-2"
                aria-label="Search"
                style={{ backgroundImage: searchVal ? "none" : `url(${Background})` }}
                value={searchVal}
                onChange={(e) => {
                    page !== 0 && setPage(0);
                    setSearchVal(e.target.value.toLowerCase())
                }}
            />
        </Form>
    )
}

export default SearchBar